<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-facebuck">
				<rect
					id="Rectangle_15498"
					data-name="Rectangle 15498"
					width="20"
					height="20"
					transform="translate(429 619)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_44949" data-name="Mask Group 44949" transform="translate(-429 -619)" clip-path="url(#clip-path-facebuck)">
			<g id="Layer_1-2" transform="translate(429 619)">
				<circle id="Ellipse_928" data-name="Ellipse 928" cx="10" cy="10" r="10" fill="#fff" />
				<path
					id="Path_33042"
					data-name="Path 33042"
					d="M10,.05A10,10,0,0,0,8.51,19.93V12.7H6.04V10.07H8.51V8.32c0-2.9,1.41-4.17,3.82-4.17a15.828,15.828,0,0,1,2.05.12V6.56H12.74c-1.02,0-1.38.97-1.38,2.06v1.44h2.99l-.41,2.63H11.35v7.25A9.99,9.99,0,0,0,10,.05Z"
					fill="#969bae"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'FacebookSvg',
};
</script>
